import React from "react"

const { getAssumedUser, clearAssumedUser } =
  require("@pga/auth-flow-provider").impersonation

// Intercom's `#intercom-container` and friends use z-indexes in the
// 2,147,483,000 range, which sits above the upstream
// `ImpersonationOverlay` from `@pga/auth-flow-provider` (z-index 1300).
// When the Intercom Messenger is mounted/open it covers the banner and
// the "I'm Done" button becomes unclickable, stranding the impersonator.
// Render our own banner with the max 32-bit z-index so it always wins.
const Z_INDEX_ABOVE_INTERCOM = 2147483647

const ImpersonationOverlay = () => {
  const assumedUser = getAssumedUser()
  if (!assumedUser) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: Z_INDEX_ABOVE_INTERCOM,
        width: "100%",
        backgroundColor: "rgba(255, 91, 51, 0.95)",
        textAlign: "center",
        padding: "4px 8px",
      }}
    >
      <div
        style={{
          display: "inline-block",
          marginRight: "16px",
          textTransform: "uppercase",
          fontWeight: 600,
          color: "black",
        }}
      >
        You are currently impersonating PGA ID #{assumedUser.id}
      </div>
      <button onClick={() => clearAssumedUser()}>I&apos;m done</button>
    </div>
  )
}

export default ImpersonationOverlay
